export const EMAIL = "hire@franpandol.com";
